import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { AuthenticationProvider } from './auth/AuthenticationProvider';
import { useAuth } from 'react-oidc-context';
import { AuthStatus } from './components/AuthStatus';
import { redirectToDocs } from './services/api';

const LOCAL_STORAGE_DOCS_PATH_KEY = 'APTY_DOCS_PATH';
function AppContent() {
  const docsPath = window.location.pathname;
  if (docsPath && docsPath.length > 1) {
    window.localStorage.setItem(LOCAL_STORAGE_DOCS_PATH_KEY, docsPath);
  }
  const auth = useAuth();

  useEffect(() => {
    // Only initialize data when authenticated
    if (auth.isAuthenticated && auth.user?.access_token) {
      const path = window.localStorage.getItem(LOCAL_STORAGE_DOCS_PATH_KEY) || '';
      redirectToDocs(auth.user.access_token, path);
      window.localStorage.setItem(LOCAL_STORAGE_DOCS_PATH_KEY, '');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated, auth.user?.access_token]);

  return (
      <AuthStatus />
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthenticationProvider>
        <AppContent />
      </AuthenticationProvider>
    </ThemeProvider>
  );
}

export default App;
